import React from 'react';
import PlayArrow from '@material-ui/icons/PlayArrow';
import Stop from '@material-ui/icons/Stop';
import Refresh from '@material-ui/icons/Refresh';
import LinkIcon from '@material-ui/icons/Link';
import { ActionMenu } from '../../ActionMenu';
import {
  AwsActionMenuItems,
  RdsAction,
  Ec2Action,
  AsgAction,
  AWSActionType,
  AWSResourceType,
} from './types';
import {
  ListItemIcon,
  ListItemText,
  makeStyles,
  MenuItem,
} from '@material-ui/core';

interface AwsMenuProps {
  handleActionClick: (action: AWSActionType, service: AWSResourceType) => void;
  handleMenuClose: () => void;
  handleOpenConnection: () => void;
  menuPosition: { mouseX: number | null; mouseY: number | null };
  service: AWSResourceType;
}

const useStyles = makeStyles({
  truncatedText: {
    display: 'block',
    maxWidth: '300px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

const getMenuItems = (service: AWSResourceType): AwsActionMenuItems[] => {
  switch (service) {
    case 'rds': {
      return [
        {
          action: RdsAction.START,
          service: 'rds',
          icon: <PlayArrow fontSize="small" color="primary" />,
          text: 'Start RDS',
          disabled: false,
        },
        {
          action: RdsAction.STOP,
          service: 'rds',
          icon: <Stop fontSize="small" color="secondary" />,
          text: 'Stop RDS',
          disabled: false,
        },
        {
          action: RdsAction.RESTART,
          service: 'rds',
          icon: <Refresh fontSize="small" color="primary" />,
          text: 'Restart RDS',
          disabled: false,
        },
      ];
    }
    case 'ec2': {
      return [
        {
          action: Ec2Action.START,
          service: 'ec2',
          icon: <PlayArrow fontSize="small" color="primary" />,
          text: 'Start EC2',
          disabled: false,
        },
        {
          action: Ec2Action.STOP,
          service: 'ec2',
          icon: <Stop fontSize="small" color="secondary" />,
          text: 'Stop EC2',
          disabled: false,
        },
        {
          action: Ec2Action.RESTART,
          service: 'ec2',
          icon: <Refresh fontSize="small" color="primary" />,
          text: 'Restart EC2',
          disabled: false,
        },
      ];
    }
    case 'asg': {
      return [
        {
          action: AsgAction.START,
          service: 'asg',
          icon: <PlayArrow fontSize="small" color="primary" />,
          text: 'Start ASG',
          disabled: false,
        },
        {
          action: AsgAction.STOP,
          service: 'asg',
          icon: <Stop fontSize="small" color="secondary" />,
          text: 'Stop ASG',
          disabled: false,
        },
        {
          action: AsgAction.RESTART,
          service: 'asg',
          icon: <Refresh fontSize="small" color="primary" />,
          text: 'Restart ASG',
          disabled: false,
        },
      ];
    }

    default:
      return [];
  }
};

export const AwsActionMenu: React.FC<AwsMenuProps> = ({
  handleActionClick,
  handleMenuClose,
  handleOpenConnection,
  menuPosition,
  service,
}) => {
  const menuItems = getMenuItems(service);
  const classes = useStyles();

  return (
    <ActionMenu<{ action: AWSActionType; service: AWSResourceType }>
      handleActionClick={handleActionClick}
      handleMenuClose={handleMenuClose}
      menuPosition={menuPosition}
      menuItems={menuItems}
      additionalMenuItems={
        service === 'rds'
          ? [
              <MenuItem key="connect-rds" onClick={handleOpenConnection}>
                <ListItemIcon>
                  <LinkIcon fontSize="small" color="primary" />
                </ListItemIcon>
                <ListItemText>
                  <span className={classes.truncatedText}>Connect to RDS</span>
                </ListItemText>
              </MenuItem>,
            ]
          : undefined
      }
    />
  );
};
